import { render } from "./InventarioUbicacionPage.vue?vue&type=template&id=31e281d7&scoped=true"
import script from "./InventarioUbicacionPage.vue?vue&type=script&lang=js"
export * from "./InventarioUbicacionPage.vue?vue&type=script&lang=js"

import "./InventarioUbicacionPage.vue?vue&type=style&index=0&id=31e281d7&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e281d7"]])

export default __exports__